import Vue from 'vue';

/**
 * UniMicro Token Exchange
 * Exchanges authorization code for access and refresh tokens
 */
const success = function success(response, resolve) {
  resolve(response);
};

const failed = function failed(error, reject) {
  reject(error);
};

export default function token(data) {
  return new Promise((resolve, reject) => {
    Vue.$http
      .post('/unimicro/token', data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  });
}



// WEBPACK FOOTER //
// ./src/app/services/unimicro/token.js